// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d6f3296f","453":"b3a99990","455":"5272a7a6","977":"f2480869"}[chunkId] + ".chunk.js";
};